import { observer } from 'mobx-react-lite'

export const ExportXML = observer(() => {

    return(
        <>

        </>
    )
})